import { render } from "./OrderApprove.vue?vue&type=template&id=2a597ba6&scoped=true"
import script from "./OrderApprove.vue?vue&type=script&lang=js"
export * from "./OrderApprove.vue?vue&type=script&lang=js"

import "./OrderApprove.vue?vue&type=style&index=0&id=2a597ba6&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a597ba6"]])

export default __exports__